const dev = false;
export {
  dev as d
};
